export default {
  'header.description': 'IT 工具',
  'header.PROJECT_NAME': 'IT 工具',
  'home': 'home',
  'login.logout': '退出登陆',

  Watermark: '加水印',
  Combine: '合并',
  Split: '拆分',
  Tools: '工具集',
  'Add Watermark': '添加水印',
  'Watermark Template': '水印版本',
  Start: '开始',
  'Project Name': '项目名称',
  'Workspace': '工作区域，暂无数据',
  'Note Download Tips': '注：转换完成请及时下载，关闭应用数据清空',
  Files: '文件',
  'Drag and drop multiple files:': '或拖拽多个文件：',
  '(Up to 4 files, each file should be less than 100 MB)': '（最多 4 个文件，单个文件小于 100 MB）',
  '(Up to 4 files, each file should be less than 200 MB)': '（最多 4 个文件，单个文件小于 200 MB）',
  '(Up to 4 files, each file should be less than 1 GB)': '（最多 4 个文件，单个文件小于 1 GB）',
  'file uploaded successfully.': '文件上传成功。',
  'file upload failed.': '文件上传失败。',
  'You can only upload PDF files!': '您只能上传 PDF 文件！',
  'File size cannot exceed 100 MB!': '文件大小不能超过 100 MB！',
  'File size cannot exceed 1 GB!': '文件大小不能超过 1 GB！',
  'Total file size cannot exceed 1 GB!': '文件总大小不能超过 1 GB！',
  'You can only upload up to 4 files.': '最多上传 4 个文件！',
  'Do not add the same file repeatedly!': '不要重复添加相同文件!',
  'Preview': '效果预览',
  'Processing': '待处理',
  'Download': '待下载',
  'Failed': '处理失败',
  'Please select file!': '请选择文件！',
  // 通用
  Delete: '删除',
  Edit: '编辑',
  'No Permission': '没有权限',
  'Server Error': '服务器错误',
  // 水印 Agent 落地页
  '工具集 · Watermark': '工具集 · Watermark',
  '仍使用网页版 →': '仍使用网页版 →',
  '加水印工具已升级': '加水印工具已升级',
  '不用再打开这个网页了，': '不用再打开这个网页了，',
  '直接在飞书里跟 Agent 说一句话。': '直接在飞书里跟 Agent 说一句话。',
  '上传合同、选模板、填项目名——现在这三步都在飞书对话里完成，不用登录、不用记网址，水印结果几秒后直接发到你手上。': '上传合同、选模板、填项目名——现在这三步都在飞书对话里完成，不用登录、不用记网址，水印结果几秒后直接发到你手上。',
  '在飞书中打开 IT AI小助手 →': '在飞书中打开 IT AI小助手 →',
  '飞书搜索「IT AI小助手」即可开始': '飞书搜索「IT AI小助手」即可开始',
  '过渡期内网页版仍会保留，': '过渡期内网页版仍会保留，',
  '点此继续使用': '点此继续使用',
  '仍然习惯网页操作？': '仍然习惯网页操作？',
  '点此继续使用网页版加水印工具': '点此继续使用网页版加水印工具',
  '过渡期内持续可用，后续将逐步下线': '过渡期内持续可用，后续将逐步下线',
  '重播': '重播',
};
